import { useQuery } from "@tanstack/react-query";
import { getProspectActionTypes } from "@/app/actions/prospect-search/actions/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProspectActionTypes(options: { projectId?: number; enabled?: boolean }) {
  const { projectId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROSPECT_ACTION_TYPES, projectId],
    queryFn: () => getProspectActionTypes(projectId!),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
